import { render, staticRenderFns } from "./InvoiceEdit_Delivery.vue?vue&type=template&id=48c1084c&"
import script from "./InvoiceEdit_Delivery.vue?vue&type=script&lang=js&"
export * from "./InvoiceEdit_Delivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports